import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderComponent } from '../order/order.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderService } from '../order.service';
import { Order } from '../order';

@Component({
    selector: 'app-order-list',
    templateUrl: './order-list.component.html',
    styleUrls: ['./order-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderListComponent implements OnInit {
	constructor(
		private orderService: OrderService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	orders: any;
	order: Order;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'orderId', header: 'Id', width: 'auto' },
		{ field: 'createDate', header: 'CreateDate', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-order-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.orderService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orders = res.data.orders;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orders = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(order: Order) {
		try {
			this.formLoading = true;
			this.orderService.update(order)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orders.map((order, i) => {
							if (order.orderId === res.data.order.orderId) {
								this.orders[i] = res.data.order;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(order: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(order));

			this.formLoading = true;
			this.orderService.delete(order.orderId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orders.splice(this.orders.indexOf(order), 1);
						this.recordTotal = this.orders.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Order ' + order.orderId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Order ' + order.orderId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Order'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOrderCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(order: Order) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			order: order,
			title: 'Edit Order'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOrderCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOrderCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderCB(order: Order) {
		console.log('Adding Order: ' + JSON.stringify(order));
		// if we don't have a orders array yet...
		if (!this.orders) {
			this.orders = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orders.unshift(order);

		// no idea what this is but it is required to update the array
		this.orders = [...this.orders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order ' + order.orderId + ' Added', life: 3000 });
	}

	updateOrderCB(order: Order) {
		console.log('Updating Order: ' + JSON.stringify(order));
		let itemIndex = this.orders.findIndex((item: any) => item.orderId === order.orderId);
		this.orders[itemIndex] = order;

		// no idea what this is but it is required to update the array
		this.orders = [...this.orders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order ' + order.orderId + ' Updated', life: 3000 });
	}

	deleteOrderCB(order: Order) {
		console.log('Removing Order: ' + order);
		this.orders.splice(this.orders.indexOf(order), 1);
		this.recordTotal = this.orders.length;

		// no idea what this is but it is required to update the array
		this.orders = [...this.orders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Order ' + order.orderId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orders ? this.first === (this.orders.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orders ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(order: any) {
		if (order?.status) {
			const status = this.statuses.find((e: any) => e.value == order.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
